var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterestingLinksIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 15,
    viewBox: "0 0 26 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 0.974609H14.25V3.62167H19.25C21.3125 3.62167 23 5.40843 23 7.59226C23 9.77608 21.3125 11.5628 19.25 11.5628H14.25V14.2099H19.25C22.7 14.2099 25.5 11.2452 25.5 7.59226C25.5 3.93932 22.7 0.974609 19.25 0.974609ZM11.75 11.5628H6.75C4.6875 11.5628 3 9.77608 3 7.59226C3 5.40843 4.6875 3.62167 6.75 3.62167H11.75V0.974609H6.75C3.3 0.974609 0.5 3.93932 0.5 7.59226C0.5 11.2452 3.3 14.2099 6.75 14.2099H11.75V11.5628ZM8 6.26873H18V8.91579H8V6.26873Z",
    fill: "#00BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestingLinksIcon);
export default __webpack_public_path__ + "static/media/interestingLinksIcon.a01ca93a7871a4879939a459cbefcb44.svg";
export { ForwardRef as ReactComponent };